export default __webpack_public_path__ + "static/media/logo_blanco.8de2eb97.png";